var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-in-page"},[_c('h2',{staticClass:"title"},[_vm._v("Sign in")]),_c('b-button',{attrs:{"icon-left":"google","type":"is-info"},on:{"click":_vm.onSignInClick}},[_vm._v(" Sign in with Google ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }